<template>
  <div class="BusinessLikeListModel">
    <div class="like-comment-wrapper">
      <header>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 14.351 14.395"
          @click="CloseLikeListModel"
        >
          <path
            class="a"
            d="M.2,1.168A.7.7,0,0,1,.2.2.7.7,0,0,1,1.17.2L7,6.035,12.837.2a.683.683,0,1,1,.961.971L7.97,7,13.8,12.836a.683.683,0,1,1-.961.971L7,7.969,1.17,13.807a.7.7,0,0,1-.971,0,.7.7,0,0,1,0-.971L6.028,7Z"
            transform="translate(0.198 0.196)"
          />
        </svg>
        <span v-if="feeds[userIndex] && feeds[userIndex].likes">{{feeds[userIndex].likes.length}} {{$t('Peoplehaveliked')}}</span>
      </header>
      <ul v-if="feeds[userIndex] && feeds[userIndex].likes">
        <li v-for="(userlikes,index) in feeds[userIndex].likes" :key="index">
          <span>
            <img :src="userlikes.user_img" v-if="userlikes.user_img" />
            <img src="../../assets/images/user_images.png" v-else/>
            
          </span>

 <div class="name-comment">
            <span class="nameLike">
              {{userlikes.user}}
              <span class="last-comment-time">
                <timeago :datetime="userlikes.time * 1000" :auto-update="60" />
                </span>
            </span>
          </div>
          <!-- <span class="user-name">{{userlikes.user}}</span>
          <span>2019,23-2-1</span> -->
        </li>
      </ul>
    </div>
      <div class="loader" v-if="loading">
      <img src="../../assets/images/gif-loader.gif" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "BusinessLikeListModal",
  components: {},
  props: {
    userIndex:null
  },
  data() {
    return {
      loading:false,
    
    };
  },
    computed: {
    ...mapState(["feeds"])
  },
  methods: {
    CloseLikeListModel() {
      document.querySelector("body").classList.remove("BusinessLikeList_Body");
    }
  },

  beforeDestroy() {
    document.querySelector("body").classList.remove("BusinessLikeList_Body");
  },
  mounted() {
    
  }
};
</script>
<style></style>
